import { Locales } from 'src/i18n'
import Translation from '../shared/interfaces/Translation'
import ContentBlockTranslationJson from './interfaces/ContentBlockTranslationJson'

export default class ContentBlockTranslation implements Translation {
  locale: Locales
  content: string

  constructor(locale: Locales, content: string) {
    this.locale = locale
    this.content = content
  }

  static fromJson(data: ContentBlockTranslationJson) {
    return new this(data.locale, data.content)
  }

  toJson(): ContentBlockTranslationJson {
    return {
      locale: this.locale,
      content: this.content,
    }
  }
}
